module.exports = __webpack_public_path__ + "img/ep-logo-outline.33b72f29.png";